module.exports = __webpack_public_path__ + "assets/img/script.e85e0116.svg";